import { ProductDetailsContextProvider } from "./ProductDetailsView";
import ProductDetails from "./views/ProductDetails";

export const ProductDetailsPage = () => {
  return (
    <ProductDetailsContextProvider>
      <ProductDetails />
    </ProductDetailsContextProvider>
  );
};
